module.exports = __webpack_public_path__ + "img/IMG_9806.349dcf10.jpeg";